export const isTempEmail = (email = ''): boolean =>
  email.startsWith('generated_') && email.endsWith('shop-apotheke.com')

export const isUnspecifiedTempUser = (salutation: string): boolean =>
  salutation === 'unspecified'
